// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4f9d6e2","239":"bfc31400","732":"3ec283ce"}[chunkId] + ".chunk.js";
};